import { BudgetCapping } from '../../../../__generated__/graphql'

export const DEFAULT_ADGROUP_BUDGET_CAPPING_TYPE = BudgetCapping.Period
